import { Component, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators, UntypedFormArray, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PopupService } from '../../service/popup.service';
import { MessageService } from '../../service/message.service';
import { CalculationService } from '../../service/calculation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Global } from '../../../shared/global';
import {
  toggleEditMode, getExpertMode, getMotorrad, getQuery, getOffertBaseId,
  convertBase64ToPdf, getOffertBase, getPartnerId, getPartner, getVerifyOffert, getOffertAntrag, getResetPasscode, showRegion, showBmStufe, getFertigstellen, validateExcludeAgbs,
} from '../../../shared/utils';
import { merge, ReplaySubject, interval, Subject, Observable, BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DateService } from '../../service/date.service';
import * as moment from 'moment';
import { map, switchMap, first, debounce, flatMap } from 'rxjs/operators';
import { OffertComponent } from '../offert/offert.component';
import { AntragComponent } from '../antrag/antrag.component';
import { CustomValidator } from '../../../shared/validation';
import { OffertService } from 'src/app/service/offert.service';
import { IKfzOffert } from '../../models/kfzoffert';
import { ILdstellenResult, ILookupValue } from '../../models/lookupvalues';
import { IKfzResult } from '../../models/kfzresult';
import { IKfzRisiko } from '../../models/kfzrisiko';
import { IKfzKasko } from '../../models/kfzkasko';
import { IKfzHaftpflicht } from '../../models/kfzhaftpflicht';
import { IKfzInsassen } from '../../models/kfzinsassen';
import { IKfzProdukt } from '../../models/kfzprodukt';
import { AntragService } from '../../service/antrag.service';
import { IKfzAntrag } from '../../models/kfzantrag';
import { KfzAntragComponent } from '../antrag/kfz-antrag/kfz-antrag.component';
import { OffertBaseService } from '../../service/offert.base.service';
import { KaskoKfzComponent } from './kaskokfz/kaskokfz.component';
import { LookupService } from '../../service/lookup.service';
import { AntragWeitereFragenComponent } from '../antrag/antrag-weitere-fragen/antrag-weitere-fragen.component';
import { PraemienStatus, IPraemieStatus } from '../../../shared/praemie';
import { VereinbarungKommunikationComponent } from '../vereinbarung-kommunikation/vereinbarung-kommunikation.component';
import { DatenschutzPolicyComponent } from '../datenschutz-policy/datenschutz-policy.component';
import { VersicherungsbestaetigungComponent } from '../versicherungsbestaetigung/versicherungsbestaetigung.component';
import { MatStepper } from '@angular/material/stepper';
import { LookupGroup, valueGroupOptions } from '../../../shared/autocomplete';
import { CurrentRechner } from '../../../shared/rechner';
import { DatenBeratungsprotokollComponent } from '../daten-beratungsprotokoll/daten-beratungsprotokoll.component';
import { RisikoKfzComponent } from './risikokfz/risikokfz.component';
import { KfzZusammenfassungComponent } from '../zusammenfassung/kfz-zusammenfassung/kfz-zusammenfassung.component';
import { DataService } from '../../service/data.service';
import { OffertVerificationDialogService } from '../../service/offert-verification-dialog.service';
import { ProduktArt, ErrorMessageType, UploadDokumentArt } from '../../../shared/enum';
import { ProcessingService } from '../../service/processing.service';
import { KfzFertigstellenComponent } from '../fertigstellen/kfz-fertigstellen/kfz-fertigstellen.component';
import { ValidationService } from '../../service/validation.service';
import { IFile } from '../../models/file';
import { PiwikService } from 'src/app/service/piwik.service';
import { SettingsService } from '../../service/settings.service';
import { FriendlycaptchaWidgetComponent } from '../friendlycaptcha-widget/friendlycaptcha-widget.component';
import { VermittlerService } from '../../service/vermittler.service';
import { CalculateComponent } from '../calculate/calculate.component';

@Component({
  selector: 'app-calculatekfz',
  templateUrl: './calculatekfz.component.html',
  styleUrls: ['./calculatekfz.component.scss']
})
export class CalculateKfzComponent extends CalculateComponent implements OnInit, AfterViewInit {

  @ViewChild('firstFormGroupDirective') firstFormGroupDirective: FormGroupDirective;
  @ViewChild('secondFormGroupDirective') secondFormGroupDirective: FormGroupDirective;
  @ViewChild('thirdFormGroupDirective') thirdFormGroupDirective: FormGroupDirective;
  @ViewChild('fourthFormGroupDirective') fourthFormGroupDirective: FormGroupDirective;
  @ViewChild('fifthFormGroupDirective') fifthFormGroupDirective: FormGroupDirective;
  @ViewChild('sixthFormGroupDirective') sixthFormGroupDirective: FormGroupDirective;
  @ViewChild('seventhFormGroupDirective') seventhFormGroupDirective: FormGroupDirective;

  @ViewChildren('angebotTeaser', { read: ElementRef }) angebotTeaserList: QueryList<ElementRef>;
  @ViewChildren('antragTeaser', { read: ElementRef }) antragTeaserList: QueryList<ElementRef>;
  @ViewChildren('fertigstellenTeaser', { read: ElementRef }) fertigstellenTeaserList: QueryList<ElementRef>;

  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;
  fourthFormGroup: UntypedFormGroup;
  fifthFormGroup: UntypedFormGroup;
  sixthFormGroup: UntypedFormGroup;
  seventhFormGroup: UntypedFormGroup;


  fahrzeugarten = new ReplaySubject<Array<ILookupValue>>();
  verwendungsbestimmungen = new ReplaySubject<Array<ILookupValue>>();
  antriebsarten = new ReplaySubject<Array<ILookupValue>>();
  bmStufen = new ReplaySubject<Array<ILookupValue>>();
  bmStufenKasko = new ReplaySubject<Array<ILookupValue>>();
  personenArten = new ReplaySubject<Array<ILookupValue>>();
  regionen = new ReplaySubject<Array<ILookupValue>>();
  versicherungssummeVarianten = new ReplaySubject<Array<ILookupValue>>();
  insassenVarianten = new ReplaySubject<Array<ILookupValue>>();
  zahlungsarten = new ReplaySubject<Array<ILookupValue>>();
  ldstellen = new ReplaySubject<ILdstellenResult>();

  beginndatumMinDate: Date;
  beginndatumMaxDate: Date;
  geburtsdatumMinDate: Date;
  geburtsdatumMaxDate: Date;
  jahrespraemieMin = 123;

  kfzResult: IKfzResult = {} as IKfzResult;
  praemie: IPraemieStatus;

  calculateRate$ = new Subject();
  createOffert$ = new Subject();
  createAntrag$ = new Subject();
  submitAntrag$ = new Subject();
  passcode$ = new BehaviorSubject<string>('');

  expertMode: boolean;
  motorrad: boolean;
  offertBaseId: number;
  offertBase: boolean;
  partnerId: number;
  partner: boolean;
  verifyOffert: boolean;
  offertAntrag: boolean;
  fertigstellen: boolean;
  eingereicht: boolean;
  resetPasscode: boolean;

  kuendigungRisiken = false;
  korrektur = false;
  progressBarValue = 0;
  submitted = false;
  submittedFiles: IFile[];
  motorsteuerElektroInfoPopupPending = false;
  motorsteuerInfoPopupStepperSelectedIndex = 2;

  produktArt = ProduktArt;

  regionGroupOptions: Observable<LookupGroup[]>;

  antragVersicherungsnehmer: UntypedFormGroup;
  offertVersicherungsnehmer: UntypedFormGroup;

  @ViewChildren(RisikoKfzComponent) risikoKfzComponents: QueryList<RisikoKfzComponent>;
  @ViewChildren(KaskoKfzComponent) kaskoKfzComponents: QueryList<KaskoKfzComponent>;
  @ViewChild(OffertComponent) offertComponent: OffertComponent;
  @ViewChild(AntragComponent) antragComponent: AntragComponent;
  @ViewChild(KfzAntragComponent) kfzAntragComponent: KfzAntragComponent;
  @ViewChild(DatenBeratungsprotokollComponent) datenBeratungsprotokollComponent: DatenBeratungsprotokollComponent;
  @ViewChild(AntragWeitereFragenComponent) antragWeitereFragenComponent: AntragWeitereFragenComponent;
  @ViewChild(VersicherungsbestaetigungComponent) versicherungsbestaetigungComponent: VersicherungsbestaetigungComponent;
  @ViewChild(KfzZusammenfassungComponent) kfzZusammenfassungComponent: KfzZusammenfassungComponent;
  @ViewChild(KfzFertigstellenComponent) kfzFertigstellenComponent: KfzFertigstellenComponent;

  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('stepper', { read: ElementRef }) stepperRef: ElementRef;

  @ViewChild('fourthFormGroupFriendlycaptchaWidget') fourthFormGroupFriendlycaptchaWidgetComponent: FriendlycaptchaWidgetComponent;
  @ViewChild('sixthFormGroupFriendlycaptchaWidget') sixthFormGroupFriendlycaptchaWidgetComponent: FriendlycaptchaWidgetComponent;
  @ViewChild('seventhFormGroupFriendlycaptchaWidget') seventhFormGroupFriendlycaptchaWidgetComponent: FriendlycaptchaWidgetComponent;

  constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private calculationService: CalculationService, public translateService: TranslateService,
    private dateService: DateService, public popupService: PopupService, private offertService: OffertService, private offertBaseService: OffertBaseService,
    private antragService: AntragService, private ref: ChangeDetectorRef, public lookupService: LookupService, private praemienStatus: PraemienStatus,
    private currentRechner: CurrentRechner, private offertVerificationDialogService: OffertVerificationDialogService, public validationService: ValidationService,
    public dataService: DataService, private messageService: MessageService, private processingService: ProcessingService, private piwik: PiwikService,
    public settingsService: SettingsService, public vermittlerService: VermittlerService) {

    super();

    this.expertMode = getExpertMode(this.route);
    this.motorrad = getMotorrad(this.route);
    this.offertBaseId = getOffertBaseId(this.route);
    this.offertBase = getOffertBase(this.route);
    this.partnerId = getPartnerId(this.route);
    this.partner = getPartner(this.route);
    this.verifyOffert = getVerifyOffert(this.route);
    this.offertAntrag = getOffertAntrag(this.route);
    this.fertigstellen = getFertigstellen(this.route);
    this.resetPasscode = getResetPasscode(this.route);

    this.beginndatumMinDate = this.dateService.getVertragsBeginnDatumMinDate(this.expertMode);
    this.beginndatumMaxDate = this.dateService.getVertragsBeginnDatumMaxDate();
    this.geburtsdatumMinDate = Global.GEBURTSDATUM_MIN_DATE;
    this.geburtsdatumMaxDate = this.dateService.today();

    this.calculateRate$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.calculateRate();
      });

    this.createOffert$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.createOffert();
      });

    this.createAntrag$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.createAntrag();
      });

    this.submitAntrag$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.submitAntrag();
      });

    this.currentRechner.setRechner(this.motorrad ? 'Motorrad-Rechner' : 'Kfz-Rechner');
    this.currentRechner.setProduktseite(this.motorrad ? 'https://www.hdi.at/privat/produkte/motorradversicherung.php' :
      'https://www.hdi.at/privat/produkte/autoversicherung.php');

    this.praemienStatus.getPraemie()
      .subscribe((res) => {
        this.praemie = res;
        if (this.motorsteuerElektroInfoPopupPending !== null) {
          this.motorsteuerElektroInfoPopupPending = this.antriebsartElektro;
        }
        this.openMotorsteuerInfoPopupPending();
      });

    this.offertVerificationDialogService.loadOffert$
      .subscribe((data) => {
        const offert = data as IKfzOffert;
        this.setProdukt(offert.Produkt);
        this.ref.detectChanges();
        this.antragComponent.versicherungsnehmerComponent.setPartner(offert.Versicherungsnehmer);
        if (!this.expertMode) {
          this.popupService.openOffertAntragInfoPopup(
            offert.Versicherungsnehmer, offert.Anlagedatum, this.motorrad ? 'Motorradversicherung' : 'Kraftfahrzeugsversicherung');
        }
      });
  }

  ngOnInit() {
    this.firstFormGroup = this.fb.group({
      beginndatum: new UntypedFormControl('', Validators.required),
      risikos: this.fb.array([
        RisikoKfzComponent.createFormGroup(this.fb, this.motorrad)
      ]),
      bmStufeVerband: new UntypedFormControl('', Validators.required),
      bmStufe: new UntypedFormControl('', Validators.required),
      personenArt: new UntypedFormControl('', Validators.required),
      zweiterZulassungsbesitzer: new UntypedFormControl('', Validators.required),
      geburtsdatumZweiterZulassungsbesitzer: new UntypedFormControl('', Validators.required),
      geburtsdatum: new UntypedFormControl('', Validators.required),
      region: new UntypedFormControl('', CustomValidator.requiredLookupValue),
      lenkerberechtigung: new UntypedFormControl('', [Validators.required, CustomValidator.requiredYes]),
      wkz: new UntypedFormControl('', Validators.required),
      weiteresKfz: new UntypedFormControl('', Validators.required)
    });
    this.secondFormGroup = this.fb.group({
      versicherungssummeVariante: new UntypedFormControl('', Validators.required),
      kaskos: this.fb.array([
        KaskoKfzComponent.createFormGroup(this.fb, this.motorrad, this.expertMode)
      ]),
      insassenLenkerVariante: new UntypedFormControl('', Validators.required),
      insassenVariante: new UntypedFormControl('', Validators.required),
      lenkerVariante: new UntypedFormControl('', Validators.required)
    });
    this.thirdFormGroup = this.fb.group({
      zahlungsart: new UntypedFormControl('', Validators.required)
    });
    this.fourthFormGroup = this.fb.group({
      offert: OffertComponent.createFormGroup(this.fb, this.expertMode),
      vereinbarungKommunikation: VereinbarungKommunikationComponent.createVereinbarungKommunikation(),
      datenschutzPolicy: DatenschutzPolicyComponent.createDatenschutzPolicy()
    });
    this.fifthFormGroup = this.fb.group({
      antrag: AntragComponent.createFormGroup(this.fb, this.expertMode),
      kfzAntrag: KfzAntragComponent.createFormGroup(this.fb),
      datenBeratungsprotokoll: DatenBeratungsprotokollComponent.createFormGroup(this.fb),
      antragsart: new UntypedFormControl('', Validators.required),
      antragWeitereFragen: AntragWeitereFragenComponent.createFormGroup(this.fb)
    });
    this.sixthFormGroup = this.fb.group({
      kfzZusammenfassung: KfzZusammenfassungComponent.createFormGroup(this.fb)
    });
    this.seventhFormGroup = this.fb.group({
      kfzFertigstellen: KfzFertigstellenComponent.createFormGroup(this.fb)
    });

    this.loadFahrzeugarten();
    this.loadVerwendungsbestimmungen();
    this.loadAntriebsarten();
    this.loadBmStufen();
    this.loadPersonenarten();
    this.loadRegionen();
    this.loadZahlungsarten();
    this.loadLdstellen();

    this.ref.detectChanges();

    this.onValueChanged();
    this.toggleEditMode();

    if (this.offertBase) {
      this.ref.detectChanges();
      this.loadOffertBase();
    } else if (this.verifyOffert) {
      this.verifyOffertLink();
    } else if (this.resetPasscode) {
      this.sendPasscodeGeneratedNotification();
    } else {
      this.beginndatum.setValue(moment(this.dateService.today()));
    }

    this.antragVersicherungsnehmer = this.antragComponent?.versicherungsnehmerComponent.formGroup;
    this.offertVersicherungsnehmer = this.offertComponent?.versicherungsnehmerComponent.formGroup;
  }

  ngAfterViewInit() {
    this.angebotTeaserList.changes.subscribe(() => {
      if (this.angebotTeaserList.length > 0) {
        (this.angebotTeaserList.first.nativeElement as HTMLElement).scrollIntoView();
      }
    });
    this.antragTeaserList.changes.subscribe(() => {
      if (this.antragTeaserList.length > 0) {
        (this.antragTeaserList.first.nativeElement as HTMLElement).scrollIntoView();
      }
    });
    this.fertigstellenTeaserList.changes.subscribe(() => {
      if (this.fertigstellenTeaserList.length > 0) {
        (this.fertigstellenTeaserList.first.nativeElement as HTMLElement).scrollIntoView();
      }
    });
  }

  get beginndatum() { return this.firstFormGroup.get('beginndatum'); }
  get risikos() { return this.firstFormGroup.get('risikos') as UntypedFormArray; }
  get bmStufeVerband() { return this.firstFormGroup.get('bmStufeVerband'); }
  get bmStufe() { return this.firstFormGroup.get('bmStufe'); }
  get personenArt() { return this.firstFormGroup.get('personenArt'); }
  get zweiterZulassungsbesitzer() { return this.firstFormGroup.get('zweiterZulassungsbesitzer'); }
  get geburtsdatumZweiterZulassungsbesitzer() { return this.firstFormGroup.get('geburtsdatumZweiterZulassungsbesitzer'); }
  get geburtsdatum() { return this.firstFormGroup.get('geburtsdatum'); }
  get region() { return this.firstFormGroup.get('region'); }
  get lenkerberechtigung() { return this.firstFormGroup.get('lenkerberechtigung'); }
  get wkz() { return this.firstFormGroup.get('wkz'); }
  get weiteresKfz() { return this.firstFormGroup.get('weiteresKfz'); }

  get versicherungssummeVariante() { return this.secondFormGroup.get('versicherungssummeVariante'); }
  get kaskos() { return this.secondFormGroup.get('kaskos') as UntypedFormArray; }

  get insassenLenkerVariante() { return this.secondFormGroup.get('insassenLenkerVariante'); }
  get insassenVariante() { return this.secondFormGroup.get('insassenVariante'); }
  get lenkerVariante() { return this.secondFormGroup.get('lenkerVariante'); }

  get zahlungsart() { return this.thirdFormGroup.get('zahlungsart'); }

  get vboffert() { return this.fourthFormGroup.get('vb'); }
  get offert() { return this.fourthFormGroup.get('offert'); }
  get vereinbarungKommunikationOffert() { return this.fourthFormGroup.get('vereinbarungKommunikation'); }
  get datenschutzPolicyOffert() { return this.fourthFormGroup.get('datenschutzPolicy'); }

  get antrag() { return this.fifthFormGroup.get('antrag'); }
  get antragsart() { return this.fifthFormGroup.get('antragsart'); }
  get kfzAntrag() { return this.fifthFormGroup.get('kfzAntrag'); }
  get datenBeratungsprotokoll() { return this.fifthFormGroup.get('datenBeratungsprotokoll'); }
  get antragWeitereFragen() { return this.fifthFormGroup.get('antragWeitereFragen'); }

  get kfzZusammenfassung() { return this.sixthFormGroup.get('kfzZusammenfassung'); }

  get kfzFertigstellen() { return this.seventhFormGroup.get('kfzFertigstellen'); }

  get showBmStufeVerband() {
    return this.showBmStufe && this.expertMode;
  }
  get showBmStufe() {
    return showBmStufe(this.motorrad, this.risikoKfzComponents);
  }
  get showZweiterZulassungsbesitzer() {
    return this.personenArt.value && this.personenArt.value.Key === '0' ? true : false;
  }
  get showGeburtsdatum() {
    return this.personenArt.value && this.personenArt.value.Key !== '2' ? true : false;
  }
  get showGeburtsdatumZweiterZulassungsbesitzer() {
    return this.showZweiterZulassungsbesitzer && this.zweiterZulassungsbesitzer.value === 'ja' ? true : false;
  }
  get showRegion() {
    return showRegion(this.motorrad, this.risikoKfzComponents);
  }
  get showLenkerberechtigung() {
    return !this.isFirma && (this.motorrad || !this.expertMode || this.expertMode &&
      this.risikoKfzComponents?.first.fahrzeugart.value && this.risikoKfzComponents?.first.fahrzeugart.value.Key !== '1') ? true : false;
  }
  get showWkz() {
    return this.expertMode && this.risikoKfzComponents?.first.fahrzeugart.value &&
      (this.risikoKfzComponents?.first.fahrzeugart.value.Key === '15' || this.risikoKfzComponents?.first.fahrzeugart.value.Key === '12') ? true : false;
  }
  get showWeiteresKfz() {
    return this.showWkz && this.wkz.value === 'ja';
  }
  get showInsassenLenkerVariante() {
    return !this.motorrad && this.risikoKfzComponents?.some(x => x.fahrzeugart.value && (x.fahrzeugart.value.Key === '15' ||
      x.fahrzeugart.value.Key === '6' || x.fahrzeugart.value.Key === '7' || x.fahrzeugart.value.Key === '8' ||
      x.fahrzeugart.value.Key === '22'));
  }
  get showInsassenVariante() {
    return this.showInsassenLenkerVariante && this.insassenLenkerVariante.value === '1';
  }
  get showLenkerVariante() {
    return this.showInsassenLenkerVariante && this.insassenLenkerVariante.value === '2';
  }

  get isPrivatperson() {
    return !this.personenArt.value ? null : this.personenArt.value.Key === '0' ? true : false;
  }
  get isEinpersonenUnternehmen() {
    return !this.personenArt.value ? null : this.personenArt.value.Key === '1' ? true : false;
  }
  get isFirma() {
    return !this.personenArt.value ? null : this.personenArt.value.Key === '2' ? true : false;
  }

  get showKaskoversicherung() {
    return this.kaskoKfzComponents?.some(k => k.showKaskoversicherung());
  }

  get showMindestPraemie() {
    //  PKW / LKW bis 1.5t (B/M-System) / Wohnmobil bis 3,5t GGW
    return this.risikoKfzComponents?.some(k => k.fahrzeugart.value && (k.fahrzeugart.value.Key === '15' || k.fahrzeugart.value.Key === '6' || k.fahrzeugart.value.Key === '22'));
  }

  get progressPercentage(): number {
    return this.progressBarValue;
  }

  get showAngebotTeaser() {
    return this.pdfDataOffert && this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid &&
      this.fourthFormGroup.valid;
  }

  get showAntragTeaser() {
    return this.pdfDataAntrag && this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid &&
      this.fifthFormGroup.valid && this.sixthFormGroup.valid;
  }

  get showFertigstellenTeaser() {
    return this.submitted && this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid &&
      this.fifthFormGroup.valid && validateExcludeAgbs(this.sixthFormGroup) && this.seventhFormGroup.valid;
  }

  get showAntragsart() {
    return this.expertMode === true;
  }

  get showMbvInfoWohnMobile() {
    return this.risikoKfzComponents?.first.showMbvInfoWohnMobile;
  }

  get showBmNachweis() {
    return this.bmStufe.value && this.bmStufe.value.Key !== '17' &&
      (this.kfzAntragComponent?.hdiKfzMotorradVersicherung.value === '2' || this.kfzAntragComponent?.hdiKfzMotorradVersicherung.value === '3') ? true : false;
  }

  get showKaskobesichtigung() {
    return this.beginndatum.value && this.kaskoKfzComponents?.some(k => k.interesseKaskoversicherung &&
      moment(this.beginndatum.value).isAfter(moment(k.risikoKfzComponent.erstzulassungsdatum.value)));
  }

  get showAufstellungSonderausstattung() {
    return this.kaskoKfzComponents?.some(k => k.interesseKaskoversicherung && k.sonderausstattung.value);
  }

  get showSicherheitsrisikenHinweis() {
    return !!this.submittedFiles.filter(x => this.kfzFertigstellenComponent.fertigstellenComponent.antragUebernehmen.value === '1' && x.DokumentArt != UploadDokumentArt.Antrag ||
      this.kfzFertigstellenComponent.fertigstellenComponent.antragUebernehmen.value === '2').length;
  }

  get kaskoAbweichendeVorversicherungsState() {
    if (this.kfzAntragComponent.kaskoVorversicherung.value === '1') {
      return false;
    } else if (this.kfzAntragComponent.kaskoVorversicherung.value === '2') {
      return true;
    } else {
      return null;
    }
  }

  get bmStufenVerband() {
    return this.bmStufen.pipe(map(bmStufen => bmStufen.filter(x => Number(x.Key) >= 8)));
  }

  get stepperDisableSteps() {
    return this.fertigstellen || this.submitted;
  }

  antragErstellen() {
    this.stepper.selectedIndex = this.offertAntrag || this.verifyOffert ? 3 : 4;

    // create event Berechnungsreiter_AntragErstellen
    this.piwik.trackEvent('Berechnungsreiter', 'AntragErstellen');
  }

  // create event Antragsreiter_Zusammenfassung
  zurKfzZusammenfassung() {
    this.piwik.trackEvent('Antragsreiter', 'Zusammenfassung');
  }

  // create event Antrag_senden
  createKfzAntrag() {
    this.piwik.trackEvent('Antrag', 'Senden');
  }

  // create event Versicherungsumfang_Weiter
  kfzVersicherungsumfangWeiter() {
    this.piwik.trackEvent('Versicherungsumfang', 'Weiter');
  }


  showWeiterButton() {
    return !this.lenkerberechtigung.hasError('invalid') &&
      !this.geburtsdatum.hasError('matDatepickerMin') &&
      !this.geburtsdatum.hasError('matDatepickerMax') &&
      !this.geburtsdatumZweiterZulassungsbesitzer.hasError('matDatepickerMin') &&
      !this.geburtsdatumZweiterZulassungsbesitzer.hasError('matDatepickerMax') &&
      !this.risikoKfzComponents?.some(x => x.verwendungsbestimmungJaNein.hasError('invalid'));
  }

  getZahlungsarten() {
    const kaskoSelection = this.secondFormGroup.get('kaskos').value[0].kaskoVariante;
    const kasko = !kaskoSelection || kaskoSelection && kaskoSelection.Id !== null;

    // const kasko = !this.kaskoKfzComponents?.first?.kaskoVariante?.value || this.kaskoKfzComponents?.first?.kaskoVariante?.value &&
    //   this.kaskoKfzComponents?.first?.kaskoVariante?.value.Id !== null;

    const zahlungsarten = this.motorrad ?
      this.zahlungsarten.pipe(map(zahlungsarten => zahlungsarten.filter(x => x.Key !== '3' && (kasko || x.Key !== '4')))) :
      this.zahlungsarten.asObservable();

    if (this.risikoKfzComponents?.first.fahrzeugart.value && this.kaskoKfzComponents?.toArray().length > 0 &&
      this.risikoKfzComponents?.some(x => x.fahrzeugart.value?.Key === '1' // Anhaenger
        || (this.risikoKfzComponents?.first.verwendungsbestimmung.value &&
          x.fahrzeugart.value?.Key === '23' && x.verwendungsbestimmung.value?.Key === '2'))) { // Zugmaschine Verwendungszweck Forstwirtschaft
      return zahlungsarten.pipe(
        map(zahlungsarten => zahlungsarten.filter(x => x.Key === '1'))
      );
    }

    return zahlungsarten.pipe(
      map(zahlungsarten => zahlungsarten.filter(
        // allow yearly always, else check
        x => (!this.kfzResult.BruttoJaehrlich || this.kfzResult.BruttoJaehrlich >= this.jahrespraemieMin || x.Key === '1')))
    );
  }

  getZahlungsartAsNumber() {
    return Number(this.zahlungsart.value.Key);
  }

  getAntragsarten() {
    if (this.kaskoKfzComponents?.length > 1) {
      return new Map(Array.from(
        this.dataService.antragsarten).filter(([key]) => key === 1));
    }
    return this.dataService.antragsarten;
  }

  toggleEditMode(): void {
    toggleEditMode(this.bmStufeVerband, this.showBmStufeVerband);
    toggleEditMode(this.bmStufe, this.showBmStufe);
    toggleEditMode(this.zweiterZulassungsbesitzer, this.showZweiterZulassungsbesitzer);
    toggleEditMode(this.geburtsdatum, this.showGeburtsdatum);
    toggleEditMode(this.geburtsdatumZweiterZulassungsbesitzer, this.showGeburtsdatumZweiterZulassungsbesitzer);
    toggleEditMode(this.region, this.showRegion);
    toggleEditMode(this.lenkerberechtigung, this.showLenkerberechtigung);
    toggleEditMode(this.wkz, this.showWkz);
    toggleEditMode(this.weiteresKfz, this.showWeiteresKfz);
    toggleEditMode(this.insassenLenkerVariante, this.showInsassenLenkerVariante);
    toggleEditMode(this.insassenVariante, this.showInsassenVariante);
    toggleEditMode(this.lenkerVariante, this.showLenkerVariante);
    toggleEditMode(this.antragsart, this.showAntragsart);
  }

  addKfz() {
    this.risikos.push(RisikoKfzComponent.createFormGroup(this.fb, this.motorrad));
    this.ref.detectChanges();
    this.kaskos.push(KaskoKfzComponent.createFormGroup(this.fb, this.motorrad, this.expertMode));
    this.ref.detectChanges();
  }

  removeKfz(i: number) {
    this.risikos.removeAt(i);
    this.kaskos.removeAt(i);
    this.ref.detectChanges();
  }

  loadFahrzeugarten(): void {
    this.calculationService.getKfzFahrzeugarten({
      Motorrad: this.motorrad
    }).subscribe(
      data => {
        this.fahrzeugarten.next(data.KfzFahrzeugarten);
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  loadVerwendungsbestimmungen(): void {
    this.calculationService.getKfzVerwendungsbestimmungen().subscribe(
      data => {
        this.verwendungsbestimmungen.next(data.KfzVerwendungsbestimmungen);
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  loadAntriebsarten(): void {
    this.calculationService.getKfzAntriebsarten().subscribe(
      data => {
        this.antriebsarten.next(data.KfzAntriebsarten);
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  loadBmStufen(): void {
    if (!this.motorrad) {
      this.calculationService.getBmStufen().subscribe(
        data => {
          this.bmStufen.next(data.BmStufen);
          this.bmStufenKasko.next(data.BmStufen);
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
          console.log(err.message);
        }
      );
    }
  }

  loadPersonenarten(): void {
    this.calculationService.getPersonenarten().subscribe(
      data => {
        this.personenArten.next(data.Personenarten);
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  loadRegionen(): void {
    if (!this.motorrad) {
      this.calculationService.getBezirke().subscribe(
        data => {
          this.regionen.next(data.Bezirke);
          this.regionGroupOptions = valueGroupOptions(this.regionen.pipe(first(),
            flatMap(res => res), map(res => ({ category: res.Value.substring(0, 1), value: res }))), this.region);
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
          console.log(err.message);
        }
      );
    }
  }

  loadVersicherungssummeVarianten(): void {
    if (this.risikoKfzComponents?.first.fahrzeugart.valid &&
      (this.risikoKfzComponents?.first.antriebsart.disabled || this.risikoKfzComponents?.first.antriebsart.valid) &&
      this.beginndatum.valid) {
      this.calculationService.getVersicherungssummeVarianten({
        FahrzeugArtId: Number(this.risikoKfzComponents?.first.fahrzeugart.value.Id),
        AntriebsArtId: this.risikoKfzComponents?.first.antriebsart.valid ? Number(this.risikoKfzComponents?.first.antriebsart.value.Id) : null,
        TarifierungsDatum: this.beginndatum.value
      }).subscribe(
        data => {
          const versicherungssummeVarianten = data.VersicherungssummeVarianten;
          this.versicherungssummeVarianten.next(versicherungssummeVarianten);
          const versicherungssummeVariante = versicherungssummeVarianten.find(x => x.Id === this.versicherungssummeVariante.value?.Id);
          if (versicherungssummeVariante) {
            this.versicherungssummeVariante.setValue(versicherungssummeVariante);
          } else {
            this.versicherungssummeVariante.setValue(null);
          }
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
          console.log(err.message);
        }
      );
    }
  }

  getInsassenVarianten() {
    return this.insassenVarianten.pipe(map(kaskoVarianten => kaskoVarianten.filter(
      x => x.Key === '1' || x.Key === '2' || x.Key === '3'))
    );
  }

  getLenkerVarianteTop() {
    return this.insassenVarianten.pipe(map(kaskoVarianten => kaskoVarianten.find(
      x => x.Key === '5'))
    );
  }

  getLenkerVariante() {
    return this.insassenVarianten.pipe(map(kaskoVarianten => kaskoVarianten.find(
      x => x.Key === '4'))
    );
  }

  loadInsassenVarianten(): void {
    if (!this.motorrad) {
      if (this.risikoKfzComponents?.first.fahrzeugart.valid && this.beginndatum.valid) {
        this.calculationService.getInsassenVarianten({
          FahrzeugArtId: Number(this.risikoKfzComponents?.first.fahrzeugart.value.Id),
          TarifierungsDatum: this.beginndatum.value
        }).subscribe(
          data => {
            const insassenVarianten = data.InsassenVarianten;
            this.insassenVarianten.next(insassenVarianten);
            const insassenVariante = insassenVarianten?.find(x => x.Id === this.insassenVariante.value?.Id);
            if (insassenVariante) {
              this.insassenVariante.setValue(insassenVariante);
            } else {
              this.insassenVariante.setValue(null);
            }
          },
          (err: HttpErrorResponse) => {
            this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
            console.log(err.message);
          }
        );
      }
    }
  }

  loadZahlungsarten(): void {
    this.calculationService.getZahlungsarten().subscribe(
      data => {
        this.zahlungsarten.next(data.Zahlungsarten);
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  loadLdstellen(): void {
    if (!this.expertMode) {
      this.calculationService.getLdstellen().subscribe(
        data => {
          this.ldstellen.next(data);
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
          console.log(err.message);
        }
      );
    }
  }

  loadOffertBase(): void {
    this.offertBaseService.getOffertBase(getQuery(), this.offertBaseId).subscribe(
      data => {
        if (data.LinkIsValid) {
          this.offertBaseId = data.OffertBase.OffertBaseId;
          const offertBase = data.OffertBase;
          if (offertBase.Antrag === true) {
            this.setAntrag(offertBase as IKfzAntrag);
          } else {
            const kfzOffert = offertBase as IKfzOffert;
            if (this.offertAntrag) {
              this.setProdukt(kfzOffert.Produkt);
            } else {
              let idx = 0;
              if (kfzOffert.Produkt.Risikos.find(x => x.Kasko)) {
                for (const elem of kfzOffert.Produkt.Risikos) {
                  if (elem?.Kasko === null) {
                    idx = idx + 1;
                    continue;
                  }
                  this.additionalSbVariantenCall(elem, kfzOffert.Produkt.Beginndatum, idx);
                  idx = idx + 1;
                }
              }
              this.setOffert(kfzOffert);
            }
          }
          this.antragComponent.versicherungsnehmerComponent.setPartner(offertBase.Versicherungsnehmer);
          this.offertComponent.versicherungsnehmerComponent.setPartner(offertBase.Versicherungsnehmer);
        } else {
          window.location.href = data.RedirectUrl;
        }
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.OffertLoad));
        console.log(err.message);
      }
    );
  }

  additionalSbVariantenCall(risiko: IKfzRisiko, beginndatum: Date, risikoIdx: number) { //acts as hotfix, should be removed once the eurotaxservice is changed
    return new Promise<void>(resolve => {
      this.calculationService.getSelbstbehaltVarianten({
        TarifId: Number(risiko.Kasko.KaskoTarifId),
        FahrzeugArtId: Number(risiko.FahrzeugArtId),
        TarifierungsDatum: beginndatum,
        Listenpreis: Number(risiko.Kasko.ListenPreisBerechnungsWert)
      }).toPromise().then((data) => {
        const selbstbehaltVarianten = data.SelbstbehaltVarianten;
        this.kaskoKfzComponents.toArray()[risikoIdx].selbstbehaltVarianten.next(selbstbehaltVarianten);
        resolve();
      }
      );
    });
  }

  setRisikos(risikos: IKfzRisiko[]) {
    return new Promise<void>(resolve => {
      this.risikoKfzComponents.first.setRisiko(risikos[0]).then(() => {
        this.kaskoKfzComponents.first.setKasko(risikos[0]).then(() => {
          this.wkz.setValue(risikos.length > 1 ? 'ja' : 'nein');
          if (risikos.length > 1) {
            this.weiteresKfz.setValue(risikos.length > 2 ? 'ja' : 'nein');
            for (let i = 1; i < risikos.length; i++) {
              this.risikoKfzComponents.toArray()[i].setRisiko(risikos[i]).then(() => {
                this.kaskoKfzComponents.toArray()[i].setKasko(risikos[i]);
                if (i === risikos.length - 1) {
                  resolve();
                }
              });
            }
          } else {
            resolve();
          }
        });
      });
    });
  }

  setHaftpflicht(haftpflicht: IKfzHaftpflicht) {
    return new Promise<void>(resolve => {
      if (haftpflicht.VertragBmStufeId) {
        this.bmStufen.pipe(first()).toPromise().then((bmStufen) => {
          // VertragBmStufeVerbandId?: Legacy Support
          this.bmStufeVerband.setValue(bmStufen.find(x => x.Id === haftpflicht.VertragBmStufeVerbandId?.toString()));
          this.bmStufe.setValue(bmStufen.find(x => x.Id === haftpflicht.VertragBmStufeId.toString()));
          this.bmStufe.markAsDirty();
          resolve();
        });
      } else {
        resolve();
      }
      this.personenArten.pipe(first()).toPromise().then((personenArt) => {
        this.personenArt.setValue(personenArt.find(x => x.Id === haftpflicht.PersonArtId.toString()));
        this.zweiterZulassungsbesitzer.setValue(haftpflicht.ZweiterZulassungsbesitzer != null ? haftpflicht.ZweiterZulassungsbesitzer === true ? 'ja' : 'nein' : null);
        this.geburtsdatum.setValue(haftpflicht.Geburtsdatum ? moment(haftpflicht.Geburtsdatum) : null);
        this.geburtsdatumZweiterZulassungsbesitzer.setValue(haftpflicht.GeburtsdatumZweiterZulassungsbesitzer ?
          moment(haftpflicht.GeburtsdatumZweiterZulassungsbesitzer) : null);
      });
      this.regionen.pipe(first()).toPromise().then((regionen) => {
        this.region.setValue(regionen.find(x => x.Id === haftpflicht.Region));
      });
      this.versicherungssummeVarianten.pipe(first()).toPromise().then((versicherungssummeVarianten) => {
        this.versicherungssummeVariante.setValue(versicherungssummeVarianten.find(x => x.Id === haftpflicht.VersicherungsStufeId.toString()));
      });

      this.lenkerberechtigung.setValue(haftpflicht.BesitzLenkerBerechtigung != null ? haftpflicht.BesitzLenkerBerechtigung === true ? 'ja' : 'nein' : null);
    });
  }

  setInsassen(insassen: IKfzInsassen): void {
    if (insassen !== null) {
      this.insassenVarianten.pipe(first()).toPromise().then((insassenVarianten) => {
        const insassenVariante = insassenVarianten.find(x => x.Id === insassen.InsassenTarifId.toString());
        if (insassenVariante.Key === '1' || insassenVariante.Key === '2' || insassenVariante.Key === '3') {
          this.insassenLenkerVariante.setValue('1');
          this.insassenVariante.setValue(insassenVariante);
        } else if (insassenVariante.Key === '4' || insassenVariante.Key === '5') {
          this.insassenLenkerVariante.setValue('2');
          this.lenkerVariante.setValue(insassenVariante);
        }
      });
    } else {
      this.insassenLenkerVariante.setValue('3');
    }
  }

  setProdukt(produkt: IKfzProdukt) {
    return new Promise<void>(resolve => {
      this.beginndatum.setValue(moment(produkt.Beginndatum));
      this.setRisikos(produkt.Risikos).then(() => {
        this.setHaftpflicht(produkt.Haftpflicht).then(() => {
          this.zahlungsarten.pipe(first()).toPromise().then((zahlungsarten) => {
            this.zahlungsart.setValue(zahlungsarten.find(x => x.Id === produkt.ZahlungArtId.toString()));
            this.ref.detectChanges();
            resolve();
          });
        });
        this.setInsassen(produkt.Insassen);
      });
    });
  }

  setAntrag(antrag: IKfzAntrag): void {
    this.setProdukt(antrag.Produkt).then(() => {
      this.antragsart.setValue(antrag.Antragsart);
      this.kfzAntragComponent.setKfzAntrag(antrag);
      this.antragComponent.setAntrag(antrag);
      if (this.kfzFertigstellenComponent) {
        this.kfzFertigstellenComponent.fertigstellenComponent.setAntrag(antrag);
        this.kfzFertigstellenComponent.setAntrag(antrag);
        this.ref.detectChanges();
        const fileUploadComponents = this.kfzFertigstellenComponent.fertigstellenComponent.fileUploadComponents.toArray()
          .concat(this.kfzFertigstellenComponent.fileUploadComponents.toArray());
        antrag.Files.reduce(
          (m, e) => m.set(e.DokumentArt, [...m.get(e.DokumentArt) || [], e]),
          new Map()
        ).forEach((value, key) => {
          const fileUploadComponent = fileUploadComponents.filter(x => x.dokumentArt === key)[0];
          const files = value.sort((a, b) => (a.FileId < b.FileId ? -1 : 1));
          fileUploadComponent.addSelectedFiles(files);
        });
      }
    });
    this.eingereicht = antrag.Eingereicht;
    this.antragWeitereFragenComponent.setAntrag(antrag);
    this.datenBeratungsprotokollComponent.setOffertBase(antrag);
    this.kfzZusammenfassungComponent.besondereAnmerkungenComponent.setValue(antrag.BesondereAnmerkungen);
  }

  setOffert(offert: IKfzOffert): void {
    this.setProdukt(offert.Produkt);
    this.offertComponent.setOffert(offert);
  }

  getHaftpflicht(): IKfzHaftpflicht {
    return {
      VertragBmStufeVerbandId: this.bmStufeVerband.value ? Number(this.bmStufeVerband.value.Id) : null,
      VertragBmStufeId: this.bmStufe.value ? Number(this.bmStufe.value.Id) : null,
      PersonArtId: Number(this.personenArt.value.Id),
      ZweiterZulassungsbesitzer: this.zweiterZulassungsbesitzer.value != null ? this.zweiterZulassungsbesitzer.value === 'ja' : null,
      Geburtsdatum: this.geburtsdatum.value,
      GeburtsdatumZweiterZulassungsbesitzer: this.geburtsdatumZweiterZulassungsbesitzer.value,
      Region: this.region.value ? this.region.value.Id : null,
      BesitzLenkerBerechtigung: this.lenkerberechtigung.value != null ? this.lenkerberechtigung.value === 'ja' : null,
      VersicherungsStufeId: this.versicherungssummeVariante.value ? Number(this.versicherungssummeVariante.value.Id) : null,
      HdiKfzMotorradVersicherung: this.kfzAntragComponent.hdiKfzMotorradVersicherung.value ?
        this.kfzAntragComponent.hdiKfzMotorradVersicherung.value === '2' ? true : false : null,
      HdiPolizzennummer: this.kfzAntragComponent.hdiPolizzennummer.value,
      HdiPolizzenFlag: Number(this.kfzAntragComponent.hdiKfzMotorradVersicherung.value),
      Vorversicherung: this.kfzAntragComponent.vorversicherungComponent.getVorversicherung(),
      BmStufeVorversicherung: this.kfzAntragComponent.bmStufeVorversicherung.value,
      BmStufeNullJahre: this.kfzAntragComponent.bmStufeNullJahre.value,
      FirstSchadenZeitpunkt: this.kfzAntragComponent.firstSchadenZeitpunkt.value,
      SecondSchadenZeitpunkt: this.kfzAntragComponent.secondSchadenZeitpunkt.value,
      ThirdSchadenZeitpunkt: this.kfzAntragComponent.thirdSchadenZeitpunkt.value,
      StornodatumVorvertrag: this.kfzAntragComponent.stornodatumVorvertrag.value
    } as IKfzHaftpflicht;
  }

  getRisikos(): Array<IKfzRisiko> {
    const kfzRisikos: Array<IKfzRisiko> = new Array<IKfzRisiko>();
    for (let i = 0; i < this.risikoKfzComponents.length; i++) {
      const kasko: IKfzKasko = this.kaskoKfzComponents.toArray()[i] !== undefined && this.kaskoKfzComponents.toArray()[i].kaskoVariante.value &&
        this.kaskoKfzComponents.toArray()[i].kaskoVariante.value.Id !== null ?
        {
          ...this.kaskoKfzComponents.toArray()[i].getKasko(),
          KaskoAbweichendeVorversicherung: this.kaskoAbweichendeVorversicherungsState,
          Vorversicherung: this.kfzAntragComponent.kaskoVorversicherung.value === '2' ?
            this.kfzAntragComponent.kaskoVorversicherungComponent.getVorversicherung() : this.kfzAntragComponent.kaskoVorversicherung.value === '1' ?
              this.kfzAntragComponent.vorversicherungComponent.getVorversicherung() : null,
          StornodatumVorvertrag: this.kfzAntragComponent.kaskoStornodatumVorvertrag.value ? this.kfzAntragComponent.kaskoStornodatumVorvertrag.value : null,
          Kaskoschaeden: this.kfzAntragComponent.kaskoschaeden.value ? this.kfzAntragComponent.kaskoschaeden.value === 'ja' ? true : false : null,
          KaskoschaedenAnzahl: this.kfzAntragComponent.kaskoschaedenAnzahl.value ? this.kfzAntragComponent.kaskoschaedenAnzahl.value : null,
          // in expert mode we have to use the first bmStufeKasko that is shown if available
          VertragBmStufeId: this.expertMode ? this.kaskoKfzComponents?.toArray()[this.kaskoFirstIndexShown].bmStufeKasko.value ?
            Number(this.kaskoKfzComponents.toArray()[this.kaskoFirstIndexShown].bmStufeKasko.value.Id) :
            this.bmStufe.value ? Number(this.bmStufe.value.Id) : null :
            this.bmStufe.value ? Number(this.bmStufe.value.Id) : null
        } as IKfzKasko : null;
      kfzRisikos.push({
        ...this.risikoKfzComponents.toArray()[i].getRisiko(),
        Kasko: kasko
      } as IKfzRisiko);
    }
    return kfzRisikos;
  }

  getInsassen(): IKfzInsassen {
    return this.insassenLenkerVariante.value === '1' && this.insassenVariante.value ? {
      InsassenTarifId: Number(this.insassenVariante.value.Id),
      VersichertePlaetze: null
    } : this.insassenLenkerVariante.value === '2' && this.lenkerVariante.value ? {
      InsassenTarifId: Number(this.lenkerVariante.value.Id),
      VersichertePlaetze: null
    } : null;
  }

  getProdukt(): IKfzProdukt {
    return {
      Risikos: this.getRisikos(),
      Kennzeichen: this.kfzAntragComponent.kennzeichen.value,
      Haftpflicht: this.getHaftpflicht(),
      Insassen: this.getInsassen(),
      Beginndatum: this.beginndatum.value,
      ZahlungArtId: Number(this.zahlungsart.value.Id),
      ExpertMode: this.expertMode,
      Motorrad: this.motorrad
    };
  }

  getOffert(): IKfzOffert {
    return {
      ...this.offertComponent.getOffert(),
      Produkt: this.getProdukt()
    } as IKfzOffert;
  }

  getAntrag(): IKfzAntrag {
    return {
      ...this.kfzAntragComponent.getKfzAntrag(),
      ...this.antragComponent.getAntrag(),
      BesondereAnmerkungen: this.kfzZusammenfassungComponent.besondereAnmerkungen.value,
      Antragsart: this.antragsart.value ? this.antragsart.value : 1,
      ...this.antragWeitereFragenComponent.getAntrag(),
      ...this.datenBeratungsprotokollComponent.getOffertBase(),
      Produkt: this.getProdukt(),
      ...this.kfzFertigstellenComponent?.getAntrag(),
      ...this.kfzFertigstellenComponent?.fertigstellenComponent.getAntrag()
    } as IKfzAntrag;
  }

  updateResult(result: IKfzResult): void {
    this.kfzResult = result;
    this.praemienStatus.setPraemie(this.zahlungsart.value ? Number(this.zahlungsart.value.Id) : null, result.Gesamt);
  }

  calculateRate(): void {
    if (this.firstFormGroup.valid) {
      this.calculationService.calculateKfzRate(this.getProdukt(), getQuery()).subscribe(
        data => {
          this.updateResult(data);
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.CalculateRate));
          console.log(err.message);
        }
      );
    }
  }
 
  createOffert(): void {
    this.processingService.execute(
      (): boolean => this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid && this.fourthFormGroup.valid,
      (): Observable<any> => this.offertService.createKfzOffert(this.getOffert(), getQuery(),
        this.fourthFormGroupFriendlycaptchaWidgetComponent.getSolution()),
      (data: any): void => {
        this.pdfDataOffert = convertBase64ToPdf(data.OffertDocument);
        this.passcode$.next(data.Passcode);
      },
      (err: HttpErrorResponse): void => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.OffertCreate));
        console.log(err.message);
      }
    );
  }

  createAntrag(): void {
    this.processingService.execute(
      (): boolean => this.firstFormGroup.valid && this.secondFormGroup.valid && this.thirdFormGroup.valid &&
        this.fifthFormGroup.valid && this.sixthFormGroup.valid,
      (): Observable<any> => this.antragService.createKfzAntrag({ ...this.getAntrag(), Eingereicht: false, Einreichdatum: null }, getQuery(),
        this.sixthFormGroupFriendlycaptchaWidgetComponent.getSolution()),
      (data: any): void => {
        this.offertBaseId = data.AntragId;
        if (this.kfzFertigstellenComponent) {
          this.kfzFertigstellenComponent.fertigstellenComponent.offertBaseId = data.AntragId;
        }
        this.pdfDataAntrag = convertBase64ToPdf(data.Content);
      },
      (err: HttpErrorResponse): void => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.AntragCreate));
        console.log(err.message);
      }
    );
  }

  submitAntrag(): void {
    this.processingService.execute(
      (): boolean => {
        const filesValid = !this.kfzFertigstellenComponent.fertigstellenComponent.fileUploadComponents.toArray()
          .concat(this.kfzFertigstellenComponent.fileUploadComponents.toArray()).some(x => !x.valid);
        return this.seventhFormGroup.valid && filesValid && (!this.eingereicht || this.eingereicht && !!this.kfzFertigstellenComponent.selectedFiles.filter(x => !x.FileId).length);
      },
      (): Observable<any> => {
        return this.antragService.submitKfzAntrag({ OffertBaseId: this.offertBaseId, ...this.getAntrag(), Eingereicht: true },
          this.kfzFertigstellenComponent.selectedFiles, getQuery(), this.seventhFormGroupFriendlycaptchaWidgetComponent.getSolution());
      },
      (data: any): void => {
        this.submittedFiles = data;
        this.submitted = true;
      },
      (err: HttpErrorResponse): void => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.AntragCreate));
        console.log(err.message);
      }
    );
  }

  verifyOffertLink(): void {
    this.offertService.verifyOffertLink(getQuery()).subscribe(
      (data) => {
        if (data.LinkIsValid === true) {
          this.offertVerificationDialogService.openDialog(data.Privatperson);
        } else {
          this.popupService.openErrorPopup('Der von Ihnen angegebene Link ist nicht mehr gültig. Bitte fordern Sie ein neues Angebot an.');
        }
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  sendPasscodeGeneratedNotification(): void {
    this.offertService.sendPasscodeGeneratedNotification(getQuery()).subscribe(
      (data) => {
        if (data.PasscodeResetSuccessful === true) {
          this.popupService.openNewPasscodeSentInfoPopup();
        } else {
          this.translateService.get('PASSCODERESETLINKEXPIREDINFO').subscribe((text) => {
            this.popupService.openErrorPopup(text);
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  resetKfzRate(): void {
    this.kfzResult = {} as IKfzResult;
  }

  getWkz() {
    return this.risikos.at(1);
  }
  addWkz() {
    if (!this.getWkz()) {
      this.addKfz();
    }
  }
  removeWkz() {
    this.removeWeiteresKfz();
    if (this.getWkz()) {
      this.removeKfz(this.risikos.controls.indexOf(this.getWkz()));
    }
  }

  getWeiteresKfz() {
    return this.risikos.at(2);
  }
  addWeiteresKfz() {
    if (this.getWkz() && !this.getWeiteresKfz()) {
      this.addKfz();
    }
  }
  removeWeiteresKfz() {
    if (this.getWeiteresKfz()) {
      this.removeKfz(this.risikos.controls.indexOf(this.getWeiteresKfz()));
    }
  }

  setKuendigungRisiken(kuendigungRisiken: boolean) {
    this.kuendigungRisiken = kuendigungRisiken;
  }

  fahrzeugartChanged() {
    this.toggleEditMode();
  }

  parameterChanged() {
    this.calculateRate$.next();
  }

  geburtsdatumChanged(geburtsdatum: Date) {
    this.geburtsdatum.setValue(geburtsdatum);
  }

  onValueChanged(): void {
    this.beginndatum.valueChanges.subscribe(() => {
      if (this.beginndatum.value) {
        this.geburtsdatumMinDate = moment(new Date(this.beginndatum.value.toDate().getFullYear(), 0, 1)).subtract(75, 'years').toDate();
        this.geburtsdatumMaxDate = moment(new Date(this.beginndatum.value.toDate().getFullYear() + 1, 0, 1)).subtract(23, 'years').subtract(1, 'seconds').toDate();
        this.ref.detectChanges();
        this.kfzAntragComponent.setSchadenZeitpunktMinDate(this.beginndatum.value.toDate());
      }
    });
    this.personenArt.valueChanges.subscribe(() => {
      this.ref.detectChanges();
    });
    merge(
      this.personenArt.valueChanges,
      this.zweiterZulassungsbesitzer.valueChanges,
      this.wkz.valueChanges,
      this.insassenLenkerVariante.valueChanges
    ).subscribe(() => {
      this.toggleEditMode();
    });
    this.risikoKfzComponents.first.fahrzeugart.valueChanges.subscribe(() => {
      if (!this.showWkz) {
        this.wkz.reset();
      }
    });
    this.wkz.valueChanges.subscribe(() => {
      if (this.wkz.value === 'ja') {
        this.addWkz();
        this.risikoKfzComponents.toArray()[1].preselectFahrzeugart();
      } else {
        this.removeWkz();
      }
    });
    this.weiteresKfz.valueChanges.subscribe(() => {
      if (this.weiteresKfz.value === 'ja') {
        this.addWeiteresKfz();
        this.risikoKfzComponents.toArray()[2].preselectFahrzeugart();
      } else {
        this.removeWeiteresKfz();
      }
    });
    merge(
      this.risikoKfzComponents?.first.fahrzeugart.valueChanges,
      this.risikoKfzComponents?.first.antriebsart.valueChanges,
      this.beginndatum.valueChanges
    ).subscribe(() => {
      this.loadVersicherungssummeVarianten();
    });
    merge(
      this.risikoKfzComponents?.first.fahrzeugart.valueChanges,
      this.beginndatum.valueChanges
    ).subscribe(() => {
      this.loadInsassenVarianten();
    });
    this.bmStufeVerband.valueChanges.subscribe(() => {
      // && this.bmStufeVerband.value: Legacy Support
      if (this.bmStufe.pristine && this.bmStufeVerband.value) {
        this.bmStufe.setValue(this.bmStufeVerband.value);
      }
    });
    this.bmStufe.valueChanges.subscribe(() => {
      if (this.bmStufe.value.Key === '17') {
        this.kfzAntragComponent.addBmOptionKeineVorversicherung();
      } else {
        this.kfzAntragComponent.removeBmOptionKeineVorversicherung();
      }
    });
    this.bmStufe.valueChanges.pipe(
      switchMap(change => this.bmStufen.pipe(map(arr => arr.filter(e => Number(e.Key) >= Number(change?.Key)))))
    ).subscribe(res => this.bmStufenKasko.next(res));
    this.bmStufe.valueChanges.subscribe(() => {
      if (this.bmStufe.value.Key === '17') {
        this.kfzAntragComponent.addBmOptionKeineVorversicherung();
      } else {
        this.kfzAntragComponent.removeBmOptionKeineVorversicherung();
      }
    });

    // Automatische Berechnung
    merge(
      this.beginndatum.valueChanges,
      // bmStufeVerband: Legacy Support
      this.bmStufeVerband.valueChanges,
      this.bmStufe.valueChanges,
      this.personenArt.valueChanges,
      this.zweiterZulassungsbesitzer.valueChanges,
      this.geburtsdatumZweiterZulassungsbesitzer.valueChanges,
      this.geburtsdatum.valueChanges,
      this.region.valueChanges,
      this.lenkerberechtigung.valueChanges,
      this.wkz.valueChanges,
      this.weiteresKfz.valueChanges,
      this.versicherungssummeVariante.valueChanges,
      this.insassenLenkerVariante.valueChanges,
      this.insassenVariante.valueChanges,
      this.lenkerVariante.valueChanges,
      this.zahlungsart.valueChanges
    ).subscribe(() => {
      this.calculateRate$.next();
      this.resetPdfData();
    });

    merge(
      this.firstFormGroup.valueChanges,
      this.secondFormGroup.valueChanges,
      this.thirdFormGroup.valueChanges,
      this.fourthFormGroup.valueChanges,
      this.fifthFormGroup.valueChanges,
      this.sixthFormGroup.valueChanges
    ).subscribe(() => {
      this.resetPdfData();
    });

    this.zahlungsart.valueChanges.subscribe(() => {
      this.openMotorsteuerInfoPopupPending();
    });
  }

  stepChanged(event) {
    if (event.previouslySelectedIndex > event.selectedIndex) {
      event.previouslySelectedStep.interacted = false;
    }    
  }

  openMotorsteuerInfoPopupPending() {
    if (this.stepper.selectedIndex === this.motorsteuerInfoPopupStepperSelectedIndex && this.zahlungsart.value && this.motorsteuerElektroInfoPopupPending) {
      this.translateService.get('ANTRIEBSARTELEKTROMOTORSTEUERINFO')
        .subscribe((text) => {
          this.popupService.openInfoPopup(text);
        });
      this.motorsteuerElektroInfoPopupPending = null;
    }
  }

  setProgressBarValue() {
    Promise.resolve().then(() => {
      this.progressBarValue = (this.stepper?.selectedIndex > 4 && this.firstFormGroup.valid && this.secondFormGroup.valid &&
        this.thirdFormGroup.valid && this.fifthFormGroup.valid) ||
        (this.stepper?.selectedIndex === 3 && this.firstFormGroup.valid && this.secondFormGroup.valid &&
          this.thirdFormGroup.valid && this.fourthFormGroup.valid) ? 100 :

        this.stepper?.selectedIndex > 2 && this.firstFormGroup.valid &&
          this.secondFormGroup.valid &&
          this.thirdFormGroup.valid ? 80 :

          this.stepper?.selectedIndex > 1 && this.firstFormGroup.valid &&
            this.secondFormGroup.valid ? 70 :

            this.stepper?.selectedIndex > 0 && this.firstFormGroup.valid ? 50 : 0;
    });
  }

  stepAnimationDone() {
    this.setProgressBarValue();
    this.openMotorsteuerInfoPopupPending();
  }

  zusammenfassungKorrektur() {
    this.korrektur = true;
  }

  get kaskosShow() {
    return this.kaskoKfzComponents.filter(x => x.showKaskoversicherung());
  }

  get kaskoFirstIndexShown() {
    return this.kaskoKfzComponents?.toArray().indexOf(this.kaskosShow[0]);
  }

  get antriebsartElektro() {
    return this.risikoKfzComponents?.some(x => x.antriebsart.value?.Key === '6' &&
      (x.fahrzeugart.value.Key === '15' ||
        x.fahrzeugart.value.Key === '6' ||
        x.fahrzeugart.value.Key === '7' ||
        x.fahrzeugart.value.Key === '8' ||
        x.fahrzeugart.value.Key === '22' ||
        x.fahrzeugart.value.Key === '12' ||
        x.fahrzeugart.value.Key === '9') &&
      Number(x.leistungKw.value) >= 4 &&
      Number(x.gesamtgewichtKg.value ?? 0) <= 3500);
  }
}
